import Vue from 'vue';

import { read } from './message.service';
import pushService from '../../../_common/services/push.service';

async function delay(timeout) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, timeout);
    });
}

async function openModal(router, modal) {
    if (router.currentRoute.hash != modal) await router.push({ path: modal, query: router.currentRoute.query });
}

function closeModal(router, modal) {
    if (router.currentRoute.hash == modal) router.replace({ hash: null, query: router.currentRoute.query });
}

function open(router, name, params) {
    if (router.currentRoute.name != name) router.replace({ name, params });
}

async function openKiosk(router) {
    if (router.currentRoute.name == 'error' || router.currentRoute.hash === '#out-of-service') {
        await router.push({ name: 'start' });
    }
}

function lockKiosk(router) {
    if (router.currentRoute.name == 'error' || router.currentRoute.hash === '#out-of-service') return;
    // disabled opening modal "Comming Soon"
    // router.push('#out-of-service');
}
function routerToError(router) {
    if (router.currentRoute.name == 'error' || router.currentRoute.hash === '#out-of-service') return;

    router.push({ name: 'error' });
}

const allowedRouterNames = ['menu', 'internet-links', 'error'];
function redirectingFromBannedNames(router) {
    if (allowedRouterNames.includes(router.currentRoute.name)) return;

    router.replace({ name: 'start' });
}

var user = null;
function gethttpConfig() {
    return {
        headers: {
            'X-XUser-Number': user.number,
            'X-XUser-BalanceId': user.balance.id,
            'X-XUser-Alias': user.alias,
            'X-XUser-Username': user.username
        },
        timeout: 30 * 1000 // to wait responses form the localhost, to mitigate retries
    };
}

export function getAdminUrl(token) {
    return `http://localhost:5066?token=${token}`;
}

export function getReceiptUrl(receiptId) {
    return `http://localhost:5066/api/printer/${receiptId}/preview`;
}

export async function login(password) {
    return (await Vue.http.post(`http://localhost:5066/api/admin/login`, { password }, gethttpConfig())).data;
}

export async function openBillAcceptor() {
    return (await Vue.http.post(`http://localhost:5066/api/bill-acceptor/open`, {}, gethttpConfig())).data;
}

export async function closeBillAcceptor() {
    return (await Vue.http.post(`http://localhost:5066/api/bill-acceptor/close`, {}, gethttpConfig())).data;
}

export async function depositBillAcceptor() {
    return (await Vue.http.post(`http://localhost:5066/api/bill-acceptor/deposit`, {}, gethttpConfig())).data;
}

export async function payOut(amount, phone = null) {
    return (await Vue.http.post(`http://localhost:5066/api/balance/withdraw/${amount}`, { phone }, gethttpConfig())).data;
}

export async function receiptPayOut(amount, phone = null) {
    return (await Vue.http.post(`http://localhost:5066/api/balance/withdraw/receipt/${amount}`, { phone }, gethttpConfig())).data;
}

export async function dispenserPayOut(amount) {
    return (await Vue.http.post(`http://localhost:5066/api/bill-dispenser/withdraw/${amount}`, {}, gethttpConfig())).data;
}

export async function getDevicesState() {
    return (await Vue.http.get(`http://localhost:5066/api/device/state`, gethttpConfig())).data;
}

export async function printHtml(html) {
    return (await Vue.http.post(`http://localhost:5066/api/printer/print`, { html }, gethttpConfig())).data;
}

export async function printReceipt(receiptId) {
    return (await Vue.http.post(`http://localhost:5066/api/printer/${receiptId}/print`, {}, gethttpConfig())).data;
}

export async function cancelReceipt(receiptId) {
    return (await Vue.http.post(`http://localhost:5066/api/receipts/${receiptId}/cancel`, {}, gethttpConfig())).data;
}

export async function createDirectDepositOperation(options) {
    return (await Vue.http.post(`http://localhost:5066/api/direct-deposit`, options)).data;
}

export async function getDirectDepositStatus(id) {
    return (await Vue.http.get(`http://localhost:5066/api/direct-deposit/${id}`)).data;
}

export async function getDeviceLogo() {
    return (await Vue.http.get(`http://localhost:5066/api/device/logo`)).data;
}

export async function deviceIsNotActive() {
    return (await Vue.http.post('http://localhost:5066/api/device/idle', {}, gethttpConfig())).data;
}

async function checkStartBillAcceptorLoop(store, options) {
    if (!options.isLoop) return;
    if (store.state.splitBalance && store.state.splitBalance.enabled) return;

    if (store.state.modals.name && store.state.modals.name != 'deposit') {
        if (store.state.device.state.billAcceptor.status == 'active') {
            await closeBillAcceptor();
        }
    } else if (store.state.device.state.billAcceptor.status == 'connected') {
        await openBillAcceptor();
    }
    await delay(options.delay);
    checkStartBillAcceptorLoop(store, options);
}

export async function startBillAcceptorLoop(store) {
    const options = {
        isLoop: true,
        delay: 3000
    };
    checkStartBillAcceptorLoop(store, options);

    return () => (options.isLoop = false);
}

async function checkStopBillAcceptorLoop(store, options) {
    if (!options.isLoop) return;

    if (store.state.device.state.billAcceptor.status == 'active') {
        await closeBillAcceptor();
    }
    await delay(options.delay);
    checkStopBillAcceptorLoop(store, options);
}

export async function stopBillAcceptorLoop(store) {
    const options = {
        isLoop: true,
        delay: 3000
    };
    checkStopBillAcceptorLoop(store, options);

    return () => (options.isLoop = false);
}

let isSyncedWithHost = false;

export async function syncDeviceStateLoop(store, router) {
    if (store.state.device.isUpdatePaused) {
        await delay(1000);
        await syncDeviceStateLoop(store, router);
        return;
    }

    try {
        if (!store.state.player) {
            await delay(1000);
            await syncDeviceStateLoop(store, router);
            return;
        } else if (!user) {
            user = store.state.player;
        }
    } catch (error) {
        console.error('Failed to get player.', error);
        await delay(1000);
        await syncDeviceStateLoop(store, router);
        return;
    }

    try {
        // if localhost is not synced global host that stop players updates,
        // to fix issue with offline balance updates (withdrawals, deposits)
        if (!store.state.device.state.device.isSyncedWithHost) {
            if (isSyncedWithHost) Vue.state.player.setSkipUpdates(true);
        } else {
            // localhost is synced, continue player updates
            if (!isSyncedWithHost) Vue.state.player.setSkipUpdates(false);
        }
        isSyncedWithHost = store.state.device.state.device.isSyncedWithHost;
    } catch (error) {
        console.error('Failed to set up player updates', error);
    }

    let state = null;
    try {
        state = await getDevicesState();
        store.set('device/state', state);
    } catch (error) {
        console.error('Failed to sync device state.', error);
        store.set('device/state@device.isSyncedWithHost', false);
        await delay(1000);
        await syncDeviceStateLoop(store, router);
        return;
    }

    // go to multiplayer game
    if (state.splitBalance && state.splitBalance.enabled && router.currentRoute.params.gameId !== state.splitBalance.gameId) {
        router.push({
            name: `game-${state.splitBalance.provider}`,
            params: { gameId: state.splitBalance.gameId, gameProvider: state.splitBalance.provider }
        });
    }

    // close multiplayer game
    if (state.splitBalance && !state.splitBalance.enabled && router.currentRoute.params.gameId) {
        const currentGame = Vue.state.games.getById(router.currentRoute.meta.gameProvider, router.currentRoute.params.gameId);
        const gameIsMultiplayer = currentGame && currentGame.tags && currentGame.tags.includes('multiplayer');

        if (gameIsMultiplayer) {
            router.push({ name: 'start' });
        }
    }

    // Check cashier-deposit message and open modal
    const cashierDepositMessage =
        store.state.player &&
        store.state.player.notReadMessages &&
        store.state.player.notReadMessages.find(m => m.type === 'cashier-deposit');

    if (cashierDepositMessage && cashierDepositMessage.id) {
        try {
            await pushService.setRead([cashierDepositMessage.id]);
            await Vue.state.player.update();
            openModal(router, '#deposit-success');
        } catch (error) {
            console.log('Failed to mark the message "cashier-deposit" as read', error);
        }
    }
    // end Check cashier-deposit message and open modal

    try {
        if (state.device.status == 'not-registered') {
            open(router, 'admin');
        }

        if (state.device.status == 'blocked') {
            routerToError(router);
        }

        if (!state.device.isSyncedWithHost) {
            lockKiosk(router);
        } else if (state.device.status == 'registered') {
            await openKiosk(router);
        }

        // use balance from the localhost in the offline mode
        if (!state.device.isSyncedWithHost) {
            // NOTE: adjust balance because clients could perform withdrawals/deposits in offline mode
            var player = Vue.state.player.get();
            if (player.balance.real != state.device.offlineBalance.estimatedBalance) {
                console.log('offline balance changed to: ', state.device.offlineBalance.estimatedBalance);
                player.balance.real = state.device.offlineBalance.estimatedBalance;
                Vue.state.player.setBalance(player.balance);
            }
        }

        if (state.billAcceptor.status == 'active' && state.billAcceptor.pendingAmounts.length > 0) {
            openModal(router, '#deposit');
        }
        if (state.billDispenser.status == 'active') {
            openModal(router, '#payout-done');
        }

        for (let msg of state.messages) {
            console.log('got message: ', msg.code, JSON.stringify(msg.args));
            read(msg.id);

            if (msg.code == 'balance-withdraw-success') {
                // do not open the modal if a deposit direct is performed
                if (!store.state.directDeposit.isActiveOperation && router.currentRoute.hash !== '#deposit-direct-status') {
                    store.dispatch('withdraw/PAID', msg.args);
                    openModal(router, '#payout-done');
                }
            }

            if (msg.code == 'balance-direct-deposit-resumed') {
                await store.dispatch('directDeposit/startOperationUpdating', msg.args.directDepositId);
                try {
                    await router.push({ name: 'start', hash: '#deposit-direct-status' });
                } catch (error) {}
            }

            if (msg.code == 'balance-direct-deposit-completed') {
                await store.dispatch('directDeposit/startOperationUpdating', msg.args.directDepositId);
                try {
                    await router.push({ name: 'start', hash: '#deposit-direct-status' });
                } catch (error) {}
            }

            if (msg.code == 'balance-receipt-cancel-success') {
            }

            if (msg.code == 'bill-dispenser-withdraw-failed') {
                if (store.state.player.balance.real !== 0) {
                    // fix for cancel modal receipt
                    if (router.currentRoute.hash) {
                        await router.replace({ hash: null });
                    }
                    openModal(router, '#withdraw-receipt');
                }
            }

            if (msg.code == 'bill-acceptor-deposit-success') {
                store.dispatch('deposit/DONE', msg.args);
                // closeModal(router, '#deposit');
            }

            if (msg.code == 'bill-acceptor-deposit-failed') {
                store.dispatch('error/setError', { data: { message: msg.args.error, code: msg.code } });
                openModal(router, '#error');
            }

            if (msg.code == 'admin-open') {
                open(router, 'admin', { token: msg.args.token });
            }
        }
    } catch (error) {
        console.error('Failed to sync device state.', error);
    }

    await delay(2000);
    await syncDeviceStateLoop(store, router);
}



// WEBPACK FOOTER //
// ./skins/xkiosk/services/device.service.js